exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_name_div[data-v-146a7ee0]{\n    /*!*设置文字超出部分省略号*!*/overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;color:#555;font-size:15px;font-weight:700;margin-bottom:5px}", ""]);

// exports
